import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { KeycloakProfile } from 'keycloak-js';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-info-user',
  imports: [
    CommonModule
  ],
  templateUrl: './info-user.html',
  styleUrl: './info-user.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoUser implements OnInit {
  protected readonly authService = inject(AuthService);

  isLoggedIn = signal<boolean>(false);
  user = signal<KeycloakProfile | null>(null);
  userRole = signal<string>('');

  ngOnInit(): void {
    this.isLoggedIn.set(this.authService.isLoggedIn());
    this.userRole.set(this.authService.getRoles())
    this.authService.getUser().then((user: KeycloakProfile) => {
      this.user.set(user)
    })
  }

}
